export const state = () => ({
  messages: {},
})

export const getters = {
  messages(state) {
    return state.messages
  }
}

export const mutations = {
  SET_MESSAGES(state, messages) {
    state.messages = messages
  },

  ADD_MESSAGE(state, message) {
    state.messages.push(message)
  },

  UPDATE_MESSAGE(state, message) {
    let index = _.findIndex(state.messages, {id: message.id})
    
    state.messages.splice(index, 1, message)
  },
}
